// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';

import styles from './toggle_switch.module.less';

interface i_toggle_switch_props<T> {
    label: string
    value: T
    options: {label: string, value: T}[];
    cls?: string;
    on_change: (v: T)=>void;
}
export const Toggle_switch = <T, >(props: i_toggle_switch_props<T>)=>{
    const [value, set_value] = useState(props.value);
    const on_change = (v: T)=>{
        set_value(v);
        props.on_change(v);
    };
    return <div className={cn(styles.toggle_wrapper, props.cls)}>
      <div className={styles.toggle_label}>{props.label}</div>
      <div className={styles.toggle_switch}>
        {props.options.map(it=><button key={it.label}
          className={cn(styles.toggle_option, value==it.value&&styles.active)}
          onClick={()=>on_change(it.value)}
        >
          {it.label}
        </button>)}
      </div>
    </div>;
};

